<template>
  <div>
    <Header />
    <div class="content h-full sm:h-auto sm:px-12 mt-4">
      <router-view />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Header from './Header'
export default {
  mounted() {
    axios.get('/auth/me').then(response => {
      this.$store.commit('setUser', response.data.user)
    })
  },
  components: {
    Header,
  },
}
</script>

<style lang="stylus" scoped>
</style>
